import { createCrudStore } from "@/store/crudStore";
import { apiService } from "@/services/api";

const veterinarioStore = createCrudStore("inventario_veterinario");

export default {
  ...veterinarioStore,

  getters: {
    ...veterinarioStore.getters,
    productos(state) {
      return Array.isArray(state.inventario_veterinario)
        ? state.inventario_veterinario
        : [];
    },
  },
  actions: {
    ...veterinarioStore.actions,
    getProductos: veterinarioStore.actions.getAllStates,
    postProducto: veterinarioStore.actions.create,
    patchProducto: veterinarioStore.actions.update,
    deleteProducto: veterinarioStore.actions.delete,

    async getCompras() {
      const response = await apiService.getCustom(
        "inventario_veterinario/compras"
      );
      return response.data;
    },

    async postCompra(_, { productoId, data }) {
      const response = await apiService.postCustom(
        `inventario_veterinario/${productoId}/compras`,
        data
      );
      return response;
    },

    async deleteCompra(_, compraId) {
      const response = await apiService.deleteCustom(
        `inventario_veterinario/compras/${compraId}`
      );
      return response;
    },
  },
};
